import { PriceChange, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

const priceChangeColors = {
  default: 'var(--text-soft)',
  negative: 'var(--viz-bearish)',
  positive: 'var(--viz-bullish)',
};

export const PriceChangeContainer = styled.div<{
  $status: PriceChange['status'];
}>`
  display: flex;
  gap: 8px;
  color: ${props => priceChangeColors[props.$status]};
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodyXs}
`;

export const PercentageChangeLabel = styled.span`
  font-family: var(--font-roboto-mono);
  ${typographyV2.bodySm}
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LiveLabel = styled.span`
  color: var(--text-success);
  ${typographyV2.bodySm}
`;

export const DateSpan = styled.span`
  ${typographyV2.bodyXs}
  color: var(--text-soft);
`;
